import { UserOutlined, WarningTwoTone } from "@ant-design/icons";
import { Avatar, Dropdown } from "antd";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useResponsive } from "../../../hooks/useResponsive";
import { motion } from "framer-motion";
import { userState } from "../../../store/slices/loginSlice";
import { signOut } from "../../../hooks/useSignup";
import store from "../../../store/store";
import { useSelector } from "react-redux";

const ProfileDropdown = () => {
  const navigate = useNavigate();
  const state = useSelector((state) => state.login);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState();
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  const handelLogout = async () => {
    setError("");
    setIsError(false);
    try {
      signOut();
      store.dispatch(userState({}));

      localStorage.removeItem("verificationEmailSent");
      navigate("/auth/login");
    } catch (error) {
      setError(true);
      setError("faild to log out");
    }
  };
  const { mobileOnly } = useResponsive();

  const items = [
    {
      key: "1",
      label: <Link to="/">Home</Link>,
    },
    {
      key: "2",
      label: (
        <Link to={!mobileOnly ? `/profile/personal-info` : `/profile`}>
          Profile
        </Link>
      ),
    },
    {
      key: "3",
      label: <Link onClick={() => handelLogout()}>Logout</Link>,
      danger: true,
    },
  ];
  return (
    <Dropdown
      menu={{
        items,
        selectable: true,
        defaultSelectedKeys: ["1"],
      }}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <div className="border-none h-12 p-0 flex items-center justify-center gap-4">
        <p className="md:font-semibold font-medium text-base text-right md:text-lg text-primaryColor ">
          {" "}
          {state?.user?.firstName}
        </p>{" "}
        <motion.span whileTap={{ scale: 0.9 }} className="cursor-pointer">
          {state?.user?.photoURL ? (
            <span className="relative">
              <Avatar
                className="flex items-center justify-center"
                size="large"
                src={<img src={state?.user?.photoURL} alt="avatar" />}
              />{" "}
              {!state?.user?.emailVerified && (
                <span>
                  <WarningTwoTone
                    className="absolute left-0 -bottom-1"
                    twoToneColor="#faad14"
                  />
                </span>
              )}
            </span>
          ) : (
            <span className="relative">
              <Avatar
                className="flex items-center justify-center"
                size="large"
                icon={<UserOutlined />}
              />
              {!state?.user?.emailVerified && (
                <span>
                  <WarningTwoTone
                    className="absolute left-0 -bottom-1"
                    twoToneColor="#faad14"
                  />
                </span>
              )}
            </span>
          )}
        </motion.span>
      </div>
    </Dropdown>
  );
};

export default ProfileDropdown;
